let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f7aK5")).then(() => parcelRequire('19QsQ'));